export default __webpack_public_path__ + "static/media/icon-newsfeed-white.64ea4596.svg";